import type { OrganizationInfoProps } from "./organization-info.type";

import { Space } from "antd";
import { useTranslation } from "react-i18next";

import {
  FlexContainerText,
  FlexContainerImage,
} from "@/modules/flex-container";
import { InterventionTemplateLabel } from "@/modules/intervention-template/intervention-template-label";

export const OrganizationInfo = ({ organization }: OrganizationInfoProps) => {
  const { t } = useTranslation();

  const { name, description, address, logo_document, default_template } =
    organization;

  return (
    <Space orientation="vertical" size="middle">
      {name && (
        <FlexContainerText
          value={name}
          label={t("organization:form.name.label")}
        />
      )}
      {description && (
        <FlexContainerText
          value={description}
          label={t("organization:form.description.label")}
        />
      )}
      {address && (
        <FlexContainerText
          value={address}
          label={t("organization:form.address.label")}
        />
      )}
      {logo_document && (
        <FlexContainerImage
          label={t("organization:form.image.label")}
          document={logo_document}
        />
      )}
      {default_template && (
        <InterventionTemplateLabel template={default_template} />
      )}
    </Space>
  );
};
